import React from "react";
import ListGroup from "react-bootstrap/ListGroup";
import Tab from "react-bootstrap/Tab";

function Main({ activeIndex, setActiveIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <ListGroup>
                <ListGroup.Item
                    onClick={() => setActiveIndex(0)}
                    className={`p-3 ${activeIndex === 0 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    7th Convocation - 20th Jul 2025 
                </ListGroup.Item>
            <ListGroup.Item
                    onClick={() => setActiveIndex(1)}
                    className={`p-3 ${activeIndex === 1 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    6th Convocation - 21st Jul 2024 
                </ListGroup.Item>
                <ListGroup.Item
                    onClick={() => setActiveIndex(2)}
                    className={`p-3 ${activeIndex === 2 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    4th & 5th (Joint) Convocation - 22nd Feb 2024
                </ListGroup.Item>
                <ListGroup.Item
                    onClick={() => setActiveIndex(3)}
                    className={`p-3 ${activeIndex === 3 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    2nd and 3rd (Joint) Convocation - 25th Sep 2021
                </ListGroup.Item>

                <ListGroup.Item
                    onClick={() => setActiveIndex(4)}
                    className={`p-3 ${activeIndex === 4 ? " active" : ""}`}
                >
                    <i className="fas fa-chevron-circle-right me-3"></i>
                    1st Convocation - 13th Aug 2019
                </ListGroup.Item>

                
            </ListGroup>
        </Tab.Container>
    );
}
export default Main;
